<template>
  <div class="enrolling-admission-line-tuition-cell">
    <el-popover
      popper-class="enrolling-admission-line-tuition-popover"
      @keydown.enter.native="updateValue"
      @show="queryEditStatus"
      placement="top"
      width="300"
      v-model="visible">
      <div v-loading="loading">
        <template v-if="editStatus">
          <el-form ref="form" label-width="90px">
            <el-form-item label="缴纳状态：">
              <el-select v-model="tuitionStatus">
                <el-option label="已缴费" value="1"></el-option>
                <el-option label="未缴费" value="0"></el-option>
                <el-option label="部分缴费" value="2"></el-option>
                <el-option label="退费" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="更改备注：">
              <el-input v-model="remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" @click="visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="updateValue" :loading="loading">确定</el-button>
          </div>
        </template>
      </div>
      <span slot="reference" class="data" :class="rowData['tuitionStatusCode'] === '1' ? 'grid-cell-success' : rowData['tuitionStatusCode'] === '0' ? 'grid-cell-danger' : rowData['tuitionStatusCode'] === '3' ? 'grid-cell-warning' : 'grid-cell-empty'">
        {{$attrs['cell-value'] ? $attrs['cell-value'] : '未设置'}}
        <span class="icon"><i class="el-icon-edit"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EnrollingAdmissionLineTuitionCell',
  props: {
    rowData: Object
  },
  data () {
    return {
      visible: false,
      loading: false,
      tuitionStatus: null,
      remark: '',
      editStatus: false
    }
  },
  created () {
    this.tuitionStatus = this.rowData['tuitionStatusCode']
  },
  activated () {
    this.tuitionStatus = this.rowData['tuitionStatusCode']
  },
  methods: {
    queryEditStatus () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/queryEditStatus',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.editStatus = response.data['editStatus']
              if (!this.editStatus) {
                this.visible = false
                this.$message.error('已过录取上报时间，不可修改')
              }
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateValue () {
      if (!this.tuitionStatus) {
        this.$message.warning('请选择录取结果')
        return false
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/updateTuitionStatus',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id,
          tuitionStatus: this.tuitionStatus,
          remark: this.remark
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('reloadGridData')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../../../styles/color';
.enrolling-admission-line-tuition-cell {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  .data{
    cursor: pointer;
    .icon{
      color: $set-primary-color;
      margin-left: 5px;
    }
  }
}
</style>
